import React, { useEffect } from 'react'
import NewHomePage from "../home/NewThemeHomePage";

const HomepageContainer = () => {
 
  return <NewHomePage/>
}

export default HomepageContainer;